<template>
  <div class="page">
    <!-- Breadcrumb Header -->
    <div class="head-title mb-3">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#">{{ $t("products") }}</a></li>
          <li class="breadcrumb-item">
            <a href="#">{{ $t("Edite") }} {{ $t("products") }}</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">{{ form.namear }}</li>
        </ol>
      </nav>
    </div>

    <!-- Main Card Container -->
    <div class="main-card card shadow-sm p-3" id="main">
      <div class="card-header bg-transparent d-flex justify-content-between align-items-center pb-3">
        <h4 class="m-0">
          {{ $t("Edite") }} {{ $t("product") }} - {{ form.namear }}
          <span class="badge bg-info text-dark ms-2" v-if="form.kind == 1">{{ $t("prodtype1") }}</span>
          <span class="badge bg-info text-dark ms-2" v-if="form.kind == 2">{{ $t("prodtype2") }}</span>
          <span class="badge bg-info text-dark ms-2" v-if="form.kind == 3">{{ $t("prodtype3") }}</span>
        </h4>
        <button class="btn btn-primary" @click="submit">
          <i class="bi bi-save me-1"></i> {{ $t("save") }}
        </button>
      </div>

      <div class="card-body">
        <form @submit.prevent="submit">
          <!-- Details Section -->
          <h5 class="border-bottom pb-2 mb-3">{{ $t("details") }}</h5>
          
          <div class="row g-3 mb-3">
            <!-- Name AR -->
            <div class="col-md-6">
              <label class="form-label form-label-sm">{{ $t("name") }} {{ $t("ar") }}</label>
              <input type="text" class="form-control form-control-sm" v-model="form.namear" />
            </div>
            <!-- Name EN -->
            <div class="col-md-6">
              <label class="form-label form-label-sm">{{ $t("name") }} {{ $t("en") }}</label>
              <input type="text" class="form-control form-control-sm" v-model="form.nameen" />
            </div>
          </div>

          <div class="row g-3 mb-3">
            <!-- SN -->
            <div class="col-md-6">
              <label class="form-label form-label-sm">{{ $t("sn") }}</label>
              <input type="text" class="form-control form-control-sm" disabled v-model="form.sn" />
            </div>
            <!-- Item / Category -->
            <div class="col-md-6">
              <label class="form-label form-label-sm">{{ $t("item") }}</label>
              <div class="input-group input-group-sm">
                <input class="form-control" disabled v-model="form.item" />
                <button type="button" class="btn btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#categoryModal">
                  {{ $t("Edite") }}
                </button>
              </div>
            </div>
          </div>

          <div class="row g-3 mb-3">
            <!-- Unit Type -->
            <div class="col-md-6">
              <label class="form-label form-label-sm">{{ $t("unit type") }}</label>
              <select class="form-select form-select-sm" v-model="form.unittype">
                <option v-for="val in unitList" :key="val.unit" :value="val.unit">
                  {{ $t(val.unit) }}
                </option>
              </select>
            </div>
            <!-- Barcode Input -->
            <div class="col-md-6">
              <label class="form-label form-label-sm">{{ $t("barcode") }}</label>
              <input type="text" class="form-control form-control-sm" disabled v-model="form.barcode" />
            </div>
          </div>

          <!-- Barcode Print Preview -->
          <div class="row g-3 mb-4 align-items-center">
            <div class="col-md-3">
              <button class="btn btn-outline-primary btn-sm w-100" type="button" @click="print">
                <i class="bi bi-printer-fill me-1"></i> {{ $t("printe") }}
              </button>
            </div>
            <div class="col-md-6 text-end" id="barcode">
              <div class="barcode-container p-2 border rounded text-center">
                <vue3-barcode :value="form.barcode || '0'" :height="25" />
                <div class="fw-bold small">
                  {{ storeCompanyName }} - {{ form.namear }} - {{ form.salep }}
                </div>
              </div>
            </div>
          </div>

          <!-- Raw Materials Section (if kind == 2) -->
          <div v-if="form.kind == 2" class="mb-4">
            <hr />
            <h5 class="border-bottom pb-2 mb-3">
              {{ $t("details") }} {{ $t("aggregation") }} {{ $t("product") }}
            </h5>
            
            <div class="row g-2 align-items-center mb-3">
              <label class="col-auto col-form-label-sm">{{ $t("product") }}:</label>
              <div class="col-md-8">
                <select class="form-select form-select-sm" v-model="rawmaterialselect">
                  <option v-for="val in rawmaterialOptions" :key="val.id" :value="val">
                    {{ val.namear }}
                  </option>
                </select>
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-success btn-sm" @click="addRawMaterial">
                  <i class="bi bi-plus-lg"></i> {{ $t("add") }}
                </button>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-striped align-middle">
                <thead class="table-light">
                  <tr>
                    <th>{{ $t("product") }}</th>
                    <th>{{ $t("unit type") }}</th>
                    <th style="width: 15%">{{ $t("quantity") }}</th>
                    <th style="width: 15%">{{ $t("price") }}</th>
                    <th>{{ $t("total") }}</th>
                    <th style="width: 50px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(val, index) in rawmaterial" :key="val.id">
                    <td>{{ val.namear }}</td>
                    <td>{{ val.unittype }}</td>
                    <td>
                      <input type="number" step="any" class="form-control form-control-sm" v-model.number="val.pquon" />
                    </td>
                    <td>
                      <input type="number" step="any" class="form-control form-control-sm" v-model.number="val.pprice" />
                    </td>
                    <td>{{ (val.pprice * val.pquon) || 0 }}</td>
                    <td>
                      <button type="button" class="btn btn-danger btn-sm p-1" @click="removeRawMaterial(index)">
                        <i class="bi bi-dash-lg"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="fw-bold table-light">
                    <td colspan="4" class="text-end">{{ $t("total") }}</td>
                    <td colspan="2">{{ rawmaterialcost }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <!-- Accounting Section -->
          <hr />
          <h5 class="border-bottom pb-2 mb-3">{{ $t("accounting") }}</h5>

          <div class="row g-3 mb-3">
            <div class="col-md-3">
              <label class="form-label form-label-sm">{{ $t("tax") }} %</label>
              <input type="number" class="form-control form-control-sm" v-model.number="form.tax" />
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="col-md-3">
              <label class="form-label form-label-sm">{{ $t("saleprice") }}</label>
              <input type="number" step="any" class="form-control form-control-sm" v-model="form.salep" />
            </div>
            <div class="col-md-6">
              <label class="form-label form-label-sm">{{ $t("Account") }} {{ $t("sales") }}</label>
              <v-select :options="buylist" label="namear" v-model="salec" class="v-select-sm" />
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="col-md-3">
              <label class="form-label form-label-sm">{{ $t("buyprice") }}</label>
              <input type="number" step="any" class="form-control form-control-sm" v-model="form.buyp" />
            </div>
            <div class="col-md-6">
              <label class="form-label form-label-sm">{{ $t("Account") }} {{ $t("cost") }}</label>
              <v-select :options="selllist" label="namear" v-model="buyc" class="v-select-sm" />
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="col-md-3">
              <label class="form-label form-label-sm">{{ $t("sale") }} {{ $t("discount") }}</label>
              <input type="number" step="any" class="form-control form-control-sm" v-model="form.discount" />
            </div>
            <div class="col-md-3">
              <label class="form-label form-label-sm">{{ $t("minimum") }} {{ $t("balance") }} {{ $t("stock") }}</label>
              <input type="number" class="form-control form-control-sm" v-model="form.minstock" />
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Category Modal -->
    <div class="modal fade" id="categoryModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("item") }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <label class="form-label form-label-sm">{{ $t("item") }}</label>
            <v-select :options="categoryOptions" label="category" v-model="selectedCategoryModal" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal" @click="changeitem">
              {{ $t("save") }}
            </button>
            <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">
              {{ $t("cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import useValidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Vue3Barcode from "vue3-barcode";
import html2pdf from "html2pdf.js";
import vSelect from "vue-select";

export default {
  name: "EditProduct",
  components: {
    Vue3Barcode,
    vSelect,
  },
  props: ["css"],
  data() {
    return {
      v$: useValidate(),
      form: {
        namear: "",
        nameen: "",
        sn: "",
        item: "",
        unittype: "",
        barcode: "",
        tax: 0,
        salep: 0,
        buyp: 0,
        discount: 0,
        minstock: 0,
        stock: 0,
        kind: 1,
      },
      categoryOptions: [],
      unitList: [],
      selllist: [],
      buylist: [],
      rawmaterialOptions: [],
      rawmaterial: [],
      rawmaterialselect: null,
      selectedCategoryModal: null,
      salec: null,
      buyc: null,
      url: "",
    };
  },
  validations() {
    return {
      form: { required },
    };
  },
  computed: {
    rawmaterialcost() {
      return this.rawmaterial.reduce((total, item) => {
        const qty = Number(item.pquon) || 0;
        const price = Number(item.pprice) || 0;
        return total + qty * price;
      }, 0);
    },
    storeCompanyName() {
      return this.$store?.state?.cnum?.[0]?.cname || "";
    },
  },
  async mounted() {
    try {
      // Perform API calls concurrently to speed up component initialization
      const [prodRes, unitRes, catRes, accRes, rawRes] = await Promise.all([
        axios.get(`/data/productview/${this.$route.params.id}`),
        axios.get("/data/allunittypes"),
        axios.get("/data/allproductcategoriesparent"),
        axios.get("/data/accountingmanual"),
        axios.get("/data/allproducts3"),
      ]);

      this.unitList = unitRes.data.data;
      this.categoryOptions = catRes.data.data;
      this.selllist = accRes.data.data;
      this.buylist = accRes.data.data;
      this.rawmaterialOptions = rawRes.data.data;

      if (prodRes.status === 200 && prodRes.data.data.length > 0) {
        const product = prodRes.data.data[0];
        this.form = { ...product };
        
        // Parse safely
        this.rawmaterial = product.rawmaterial ? JSON.parse(product.rawmaterial) : [];
        this.url = `${store.state.imgurl}/products/${this.form.sn}.png`;

        this.salec = {
          namear: product.snamear,
          nameen: product.snameen,
          actnum: product.salec,
        };

        this.buyc = {
          namear: product.bnamear,
          nameen: product.bnameen,
          actnum: product.buyc,
        };
      }
    } catch (error) {
      console.error("Error loading product data:", error);
    }
  },
  methods: {
    ...mapActions(["redirectTo"]),

    addRawMaterial() {
      if (!this.rawmaterialselect) return;

      const exists = this.rawmaterial.some((x) => x.id === this.rawmaterialselect.id);

      if (!exists) {
        this.rawmaterial.push({
          id: this.rawmaterialselect.id,
          namear: this.rawmaterialselect.namear,
          nameen: this.rawmaterialselect.nameen,
          unittype: this.rawmaterialselect.unittype,
          pquon: 1,
          pprice: this.rawmaterialselect.buyp || 0,
        });
      } else {
        Swal.fire({
          icon: "info",
          title: "Notice",
          text: "تم اضافة المنتج من قبل",
        });
      }
    },

    removeRawMaterial(index) {
      this.rawmaterial.splice(index, 1);
    },

    changeitem() {
      if (this.selectedCategoryModal) {
        this.form.item = this.selectedCategoryModal.category;
      }
    },

    async submit() {
      try {
        const result = await axios.post("/data/productedite", {
          username: store.state.randp?.username,
          namear: this.form.namear,
          nameen: this.form.nameen,
          description: this.form.description,
          tax: this.form.tax,
          salep: this.form.salep,
          buyp: this.form.buyp,
          discount: this.form.discount,
          stock: this.form.stock,
          minstock: this.form.minstock,
          unittype: this.form.unittype,
          id: this.$route.params.id,
          item: this.form.item,
          salec: this.salec?.actnum,
          buyc: this.buyc?.actnum,
          snamear: this.salec?.namear,
          bnamear: this.buyc?.namear,
          rawmaterial: JSON.stringify(this.rawmaterial),
          rawmaterialcost: this.rawmaterialcost,
        });

        if (result.status === 200) {
          this.redirectTo({ val: "AllProducts" });

          Swal.fire({
            toast: true,
            position: "top",
            icon: "success",
            title: "Data Updated successfully",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          Swal.fire("Error", "Account Already Created Before", "error");
        } else {
          console.error("Save error:", error);
        }
      }
    },

    pdf() {
      const element = document.getElementById("barcode");
      if (!element) return;

      html2pdf(element.innerHTML, {
        margin: 0.2,
        filename: `barcode-${this.form.sn}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
    },

    print() {
      const divElements = document.getElementById("barcode")?.innerHTML;
      if (!divElements) return;

      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Barcode Print</title>
            <style>
              body { font-family: sans-serif; display: flex; justify-content: center; align-items: center; }
            </style>
          </head>
          <body>${divElements}</body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 1rem;
}

.main-card {
  border-radius: 8px;
}

.v-select-sm :deep(.vs__dropdown-toggle) {
  padding: 0 0 4px 0;
  font-size: 0.875rem;
}

.barcode-container {
  display: inline-block;
  background: #fff;
}
</style>